import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { PowerBiCoreService } from '../../services/powerbi-core.service';
import * as NavigationActions from '../actions/navigation.actions';

@Injectable()
export class NavigationEffects {
  loadNavigation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NavigationActions.loadNavigation),
      mergeMap((action) =>
        from(this.coreService.getNavigation()).pipe(
          map((routes) => NavigationActions.loadNavigationSuccess({ routes })),
          catchError((error) =>
            of(NavigationActions.loadNavigationFailure({ error })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private coreService: PowerBiCoreService,
  ) { }
}
